import TreatmentPage from "./TreatmentPage";

export default function Acne() {
  return (
    <TreatmentPage
      title="Acne & Scar Treatment"
      heroImage="/Treatment/acne_Scar-treatment-drtruptis-clinic.png"
      intro="Acne is a common skin condition caused by oil, bacteria, and hormonal imbalance. Our advanced treatments target the root cause."
      description="This treatment helps reduce acne scars and improves skin texture."
      whatIs="Acne & Scar Treatment is a dermatological procedure designed to heal the skin, reduce inflammation, and improve texture."
      whatIsImage="/images/what-is-acne.jpg"
      howItWorks="The treatment uses advanced laser and topical solutions to control oil, kill bacteria, and stimulate collagen production."
      benefits={[
        "Reduces active acne",
        "Minimizes scars",
        "Improves skin tone & texture",
        "Boosts confidence",
      ]}
      beforeAfterImages={[
        "/Treatment/befor-after-acne-treatment-drtruptis-clinic.JPG",
        "/Treatment/before-and-after-treatment-drtruptis-clinic.jpg",
      ]}
      faqs={[
        { q: "Is it painful?", a: "Mild discomfort only, done under cooling gel." },
        { q: "How many sessions needed?", a: "Usually 4-6 sessions." },
      ]}
    />
  );
}
